import React, { useState, useEffect } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import SalesChart from "./SalesChart";
import NumberOfBookings from "./NumberOfBookings";
import AnalyticsReport from "./AnalyticsReport";
import { backendApi } from '../../../api/apiService';
import { useSelector } from "react-redux";
import LoaderImage from "../../../images/spinner.gif";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import { useNavigate } from 'react-router-dom';

export default function AnalyticsDashboard() {
    const [menuClick, setMenuClick] = useState(false);
    const [Loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };

    const userDetails = useSelector((state) => state.login.userDetails);
    const [Data1, setData1] = useState([]);
    const [Data2, setData2] = useState([]);
    const [Data3, setData3] = useState([]);
    const [Data4, setData4] = useState([]);

    const [Data, setData] = useState([]);


    useEffect(() => {
        DashboardData();
        manageranAlyticsDashboard();
    }, []);

    const DashboardData = () => {
        const req = {
            functionName: "manageranAlyticsDashboard",
            site_id: userDetails[0].site_id,
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    setLoader(true)
                    console.log(response, "manageranAlyticsDashboard");
                    setData1(response.block1 || [])
                    setData2(response.block2 || [])
                    setData3(response.block3 || [])
                    setData4(response.rec_status || [])
                } else {
                    console.error("Backend responded with an error", response);
                }
            })
            .catch((error) => {
                console.error("An error occurred during the API call:", error);
            });
    };
    const manageranAlyticsDashboard = () => {
        const req = {
            functionName: "manageranAlyticsDashboardRec",
            site_id: userDetails[0].site_id,
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    setLoader(true)
                    console.log(response, "manageranAlyticsDashboardRec");
                    setData(response?.dataSet || []);
                } else {
                    console.error("Backend responded with an error", response);
                }
            })
            .catch((error) => {
                console.error("An error occurred during the API call:", error);
            });
    };
    const handleNavigate = () => {
        navigate('/Report');
    };
    const handleNavigateAgeing = () => {
        navigate('/AgeingReport');
    };
    const handleNavigateSource = () => {
        navigate('/SourceReport');
    };
    const handleNavigateInterviewType = () => {
        navigate('/IntervewTypeReport');
    };

    return (
        <>
            <div className="main-wrapper analytics-dashboard">
                <div className="top-color"></div>
                <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
                {Loader ?
                    <div className="content-wrapper">
                        <Header
                            Header="Analytics Dashboard"
                            toggleMenu={toggleMenu}
                            menuClick={menuClick}
                        />
                        <div className="main-container">

                            <>
                                <div className="row mb-3">
                                    <div className="col-md-7">
                                        {Array.isArray(Data1) && Data1.length ? (
                                            <SalesChart data={Data1} />
                                        ) : (
                                            <div>Loading Sales Data...</div>
                                        )}
                                    </div>
                                    <div className="col-md-5">
                                        {Array.isArray(Data2) && Array.isArray(Data3) ? (
                                            <NumberOfBookings data2={Data2} data3={Data3} />
                                        ) : (
                                            <div>Loading Booking Data...</div>
                                        )}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-auto mb-3">
                                        <button className="btn btn-btn2 btn-sm" onClick={handleNavigate}>
                                            Department Report
                                        </button>
                                    </div>
                                    <div className="col-auto mb-3">
                                        <button className="btn btn-btn2 btn-sm" onClick={handleNavigateAgeing}>
                                            Ageing Report
                                        </button>
                                    </div>
                                    <div className="col-auto mb-3">
                                        <button className="btn btn-btn2 btn-sm" onClick={handleNavigateSource}>
                                            Source Report
                                        </button>
                                    </div>

                                    <div className="col-auto mb-3">
                                        <button className="btn btn-btn2 btn-sm" onClick={handleNavigateInterviewType}>
                                            Interview Type Report
                                        </button>
                                    </div>
                                </div>

                                {Array.isArray(Data) && Data4 ? (
                                    <AnalyticsReport Data={Data} valueRating={Data4} />
                                ) : (
                                    <div>Loading Analytics...</div>
                                )}
                            </>

                        </div>
                    </div>
                    :
                    // <div className="main-wrapper analytics-dashboard">

                    //     <div className="content-wrapper">
                    //         <div className="main-container">
                    //             <div className="row">
                    <ShimmerCategoryItem />

                    //             </div>
                    //         </div>
                    //     </div>

                    // </div>
                }
            </div>
        </>
    )
}